import React, { useEffect } from 'react';
import { Result, Button, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout, manualLogin } from '../../store/authSlice';
import { fetchBDEs } from '../../store/bdeSlice';

const Pending = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const { users } = useSelector((state) => state.bde);

  // Check status automatically when users list updates (via polling in App.js)
  useEffect(() => {
    if (user && users.length > 0) {
      const currentUser = users.find(u => u.id === user.id);
      if (currentUser && currentUser.status === 'verified') {
        message.success('Your account has been approved!');
        dispatch(manualLogin(currentUser));
        navigate('/bde/dashboard');
      }
    }
  }, [users, user, dispatch, navigate]);

  const handleCheckStatus = async () => {
    // Manually fetch latest data
    const result = await dispatch(fetchBDEs()).unwrap();
    if (user) {
      const currentUser = result.find(u => u.id === user.id);
      if (currentUser && currentUser.status === 'verified') {
        message.success('Your account has been approved!');
        dispatch(manualLogin(currentUser));
        navigate('/bde/dashboard');
      } else {
        message.info('Account is still pending approval.');
      }
    }
  };

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
      position: 'relative',
      padding: '24px 0',
      overflowX: 'hidden'
    }}>
      {/* Decorative blobs */}
      <div style={{ position: 'absolute', top: -100, left: -100, width: 400, height: 400, background: '#2563eb', filter: 'blur(150px)', opacity: 0.2, borderRadius: '50%' }}></div>
      <div style={{ position: 'absolute', bottom: -100, right: -100, width: 400, height: 400, background: '#8b5cf6', filter: 'blur(150px)', opacity: 0.2, borderRadius: '50%' }}></div>

      <div style={{
        background: 'rgba(255, 255, 255, 0.05)',
        backdropFilter: 'blur(10px)',
        padding: 40,
        borderRadius: 24,
        border: '1px solid rgba(255, 255, 255, 0.1)',
        maxWidth: 500
      }}>
        <Result
          status="403"
          title={<span style={{ color: '#fff' }}>Account Pending</span>}
          subTitle={<span style={{ color: '#94a3b8' }}>Your account is waiting for administrator approval. Please check back later.</span>}
          extra={[
            <Button type="primary" key="check" onClick={handleCheckStatus} size="large">
              Check Status
            </Button>,
            <Button key="logout" onClick={handleLogout} size="large" ghost style={{ color: '#fff', borderColor: 'rgba(255,255,255,0.3)' }}>
              Logout
            </Button>
          ]}
        />
      </div>
    </div>
  );
};

export default Pending;
